import { IaqLimitSettings, IaqLimitSettingsPayload } from "entities/iaqLimits";
import { GET, PUT } from "utils/http";

const baseUrl = "/api/assets";

export const getLimits = (assetId: number | string) =>
  GET<IaqLimitSettings>(`${baseUrl}/${assetId}/iaq-limits`, { skipAuthRedirect: true });

export const saveLimits = (assetId: number | string, body: IaqLimitSettingsPayload) =>
  PUT<IaqLimitSettingsPayload>(`${baseUrl}/${assetId}/iaq-limits`, body);
